import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Protected Route for Super Admin Only
 * Checks if user is authenticated AND has SUPER_ADMIN role
 */
const ProtectedRouteSuperAdmin = ({ component: Component, isAuthenticated, ...rest }) => {
  // Get user from localStorage
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const rawRole = (
    user?.role || user?.role_name || user?.roleName || localStorage.getItem('roleName') || ''
  ).toString().trim();
  const normalizedRole = rawRole
    .toUpperCase()
    .replace(/\s+/g, '_')
    .replace(/-/g, '_');
  const isSuperAdmin =
    normalizedRole === "SUPER_ADMIN" ||
    normalizedRole === "SUPER_USER" ||
    normalizedRole === "SUPERUSER";

  // Check authentication
  if (!isAuthenticated()) {
    console.log("Authentication failed in ProtectedRouteSuperAdmin");
    return <Navigate to="/signin" replace />;
  }

  // Check Super Admin role
  if (!isSuperAdmin) {
    console.log("Super Admin access denied in ProtectedRouteSuperAdmin");
    return <Navigate to="/dashboard" replace />;
  }

  console.log("Super Admin access granted in ProtectedRouteSuperAdmin");
  return <Component {...rest} />;
};

export default ProtectedRouteSuperAdmin;
